export const REQUEST_RESPONSE: { [key: string]: string } = {
    error: 'Ha ocurrido un problema durante la creación de la aplicación. Por favor, intente nuevamente.'
};
